import { ResourceRequestStatus } from '~/types';
import { useMarkResourceRequestAsCompleteAndMerge } from '../../hooks';
import useMarkResourceRequestAsComplete from './useMarkResourceRequestAsComplete';
import useMarkResourceRequestAsTentative from './useMarkResourceRequestAsTentative';
import useMarkResourceRequestAsSubmitted from './useMarkResourceRequestAsSubmitted';
import useMarkResourceRequestAsRejected from './useMarkResourceRequestAsRejected';
import useMarkResourceRequestAsToBeHired from './useMarkResourceRequestAsToBeHired';
import useMarkResourceRequestAsAllocationRejected from './useMarkResourceRequestAsAllocationRejected';
import useMarkResourceRequestAsDraft from './useMarkResourceRequestAsDraft';

export const useResourceRequestStatusHandlers = ({
  resourceRequest,
  onMarkResourceRequestAsCompleteAndMergeCompleted,
  getCacheUpdateFunctions
}) => {
  const { getDefaultCacheFunctions } = getCacheUpdateFunctions
    ? getCacheUpdateFunctions()
    : {};

  const {
    onMarkResourceRequestAsComplete,
    error: markResourceRequestAsCompleteError
  } = useMarkResourceRequestAsComplete({
    resourceRequest,
    cacheUpdateFunctions: getDefaultCacheFunctions
      ? getDefaultCacheFunctions({
          responseType: 'markResourceRequestAsComplete2',
          requestStatus: ResourceRequestStatus.Complete,
          resourceRequest
        })
      : []
  });

  const {
    onMarkResourceRequestAsToBeHired
  } = useMarkResourceRequestAsToBeHired({
    resourceRequest,
    cacheUpdateFunctions: getDefaultCacheFunctions
      ? getDefaultCacheFunctions({
          responseType: 'markResourceRequestAsToBeHired2',
          requestStatus: ResourceRequestStatus.Tobehired,
          resourceRequest
        })
      : []
  });

  const {
    onMarkResourceRequestAsTentative
  } = useMarkResourceRequestAsTentative({
    resourceRequest,
    cacheUpdateFunctions: getDefaultCacheFunctions
      ? getDefaultCacheFunctions({
          responseType: 'markResourceRequestAsTentative2',
          requestStatus: ResourceRequestStatus.Tentative,
          resourceRequest
        })
      : []
  });

  const { onMarkResourceRequestAsRejected } = useMarkResourceRequestAsRejected({
    resourceRequest,
    cacheUpdateFunctions: getDefaultCacheFunctions
      ? getDefaultCacheFunctions({
          responseType: 'markResourceRequestAsRejected2',
          requestStatus: ResourceRequestStatus.Rejected,
          resourceRequest
        })
      : []
  });

  const {
    onMarkResourceRequestAsCompleteAndMerge,
    error: markResourceRequestAsCompleteAndMergeError
  } = useMarkResourceRequestAsCompleteAndMerge({
    resourceRequest,
    onCompleted: onMarkResourceRequestAsCompleteAndMergeCompleted
  });

  const {
    onMarkResourceRequestAsSubmitted
  } = useMarkResourceRequestAsSubmitted({
    resourceRequest,
    cacheUpdateFunctions: getDefaultCacheFunctions
      ? getDefaultCacheFunctions({
          responseType: 'markResourceRequestAsSubmitted2',
          requestStatus: ResourceRequestStatus.Submitted,
          resourceRequest
        })
      : []
  });

  const {
    onMarkResourceRequestAsAllocationRejected
  } = useMarkResourceRequestAsAllocationRejected({
    resourceRequest,
    cacheUpdateFunctions: getDefaultCacheFunctions
      ? getDefaultCacheFunctions({
          responseType: 'markResourceRequestAsAllocationRejected2',
          requestStatus: ResourceRequestStatus.Allocationrejected,
          resourceRequest
        })
      : []
  });

  const { onMarkResourceRequestAsDraft } = useMarkResourceRequestAsDraft({
    resourceRequest,
    cacheUpdateFunctions: getDefaultCacheFunctions
      ? getDefaultCacheFunctions({
          responseType: 'markResourceRequestAsDraft2',
          requestStatus: ResourceRequestStatus.Draft,
          resourceRequest
        })
      : []
  });

  return {
    onMarkResourceRequestAsComplete,
    markResourceRequestAsCompleteError,
    onMarkResourceRequestAsToBeHired,
    onMarkResourceRequestAsTentative,
    onMarkResourceRequestAsRejected,
    onMarkResourceRequestAsSubmitted,
    onMarkResourceRequestAsAllocationRejected,
    onMarkResourceRequestAsDraft,
    onMarkResourceRequestAsCompleteAndMerge,
    markResourceRequestAsCompleteAndMergeError
  };
};
